import React from "react";
import { FormattedMessage } from "react-intl";
import {
  type IRaangeLabelWithFAProps,
  RaangeLabel,
} from "src/shared/components/RaangeLabel";

export const ApiSubscribersLabel = ({
  children = <FormattedMessage id="apiSubscribers" />,
  ...rest
}: IRaangeLabelWithFAProps) => {
  return (
    <RaangeLabel fa="users" {...rest}>
      {children}
    </RaangeLabel>
  );
};

export const ApiSubscriberCreate = (props: IRaangeLabelWithFAProps) => {
  return (
    <RaangeLabel fa="plus" {...props}>
      <FormattedMessage id="apiSubscribers.create" />
    </RaangeLabel>
  );
};
